import { SET_DEVICE_LANGUAGE } from '../actionTypes';

const deviceLanguage = (state = 'de', action) => {
  switch (action.type) {
    case SET_DEVICE_LANGUAGE:
      return action.deviceLanguage;
    default:
      return state;
  }
};

export default deviceLanguage;
